<template>
  <div id="car-list">
    <base-list-management
      key="waitForHandleTable"
      ref="waitForHandleTable"
      :configData="waitForHandleConfig"
    />
    <!-- 上保险 -->
    <AddInsurance
      v-model="addInsuranceShow"
      :plateNo="plateNo"
      @refresh="refreshList"
    />
    <!-- 处置 -->
    <Disposal
      v-model="disposalShow"
      :plateNo="plateNo"
      :vin="vin"
      :carId="carId"
      :carState="carState"
      @refresh="refreshList"
    />
    <!-- 编辑不可租标签 -->
    <NonRentableTag
      :dialogVisible.sync="dialogVisible"
      :currentId="carId"
      :checkedList.sync="notRentableTags"
      :searchHandle="refreshList"
    />
  </div>
</template>
<script setup>
import { ref, onMounted, nextTick, computed } from 'vue'
// eslint-disable-next-line import/no-cycle
import { getEnum } from '@/api/global'
import Disposal from '../vehicleManage/components/Disposal.vue'
import AddInsurance from '@/pages/service/components/AddInsurance.vue'
import NonRentableTag from '../vehicleManage/components/tagDialog.vue'
import { useRouter, use$to, usePermission, useStore, useRoute } from '@/utils/useUtils'
// eslint-disable-next-line import/no-cycle
import { WaitForHandleConfig } from './config/waitForHandle'
import { operationUtils } from './config/index'
import { getTenantCustomTagList } from '@/api/domain/organize'
import { getCarProvider } from '@/api/carManage'
import { FuzzySearch } from '@/api/domain/cars'

const router = useRouter()
const permission = usePermission()
const $to = use$to()
const store = useStore()
const route = useRoute()

const addInsuranceShow = ref(false)
const disposalShow = ref(false)
const plateNo = ref('')
const carId = ref('')
const vin = ref('')
const carState = ref('')
const notRentableTags = ref([])
const dialogVisible = ref(false)

const waitForHandleTable = ref(null)
const carTags = ref([])
const providerList = ref([])

const cityList = computed(() => store.getters.allCities)
const refreshList = () => {
  waitForHandleTable.value.searchForm('form')
}

const batteryCoolingMethodEnum = ref([])

const setItemData = (key, data) => {
  nextTick(() => {
    waitForHandleTable.value?.setItemData({
      elConfigKey: 'list',
      key,
      data,
    })
  })
}
// 获取冷却类型
const getCoolingType = async () => {
  if (batteryCoolingMethodEnum.value.length) {
    setItemData('coolingMode', batteryCoolingMethodEnum.value)
    return
  }
  const [err, res] = await $to(getEnum({ type: 'batteryCoolingMethodEnum' }))
  if (err || res.code !== 1) return
  // eslint-disable-next-line require-atomic-updates
  batteryCoolingMethodEnum.value = res.data || []
  setItemData('coolingMode', batteryCoolingMethodEnum.value)
}

const waitForHandleOperations = operationUtils(permission, router, {
  routeName: 'vehicle_list_all_info_edit',
  getCarList: refreshList,
  addInsuranceShow,
  carPlateNo: plateNo,
  disposalShow,
  carId,
  vin,
  carState,
  notRentableTags,
  dialogVisible,
  careCarKey: 'vehicle_maintenance_list_create',
  fixCarKey: 'vehicle_maintenance_list_create',
  accidentCarKey: 'vehicle_accident_list_create',
  addLicenseKey: 'vehicle_licences_list_create',
})
const remoteCarList = (query) => {
  const keyWords = query.trim()
  if (keyWords.length > 3) {
    FuzzySearch({
      plateNo: query.trim(),
      state: 1,
    }).then((res) => {
      const { data } = res
      waitForHandleTable.value.setItemData({
        elConfigKey: 'list',
        key: 'plateNo',
        data: data || [],
      })
    })
  }
}
const waitForHandleConfig = ref(
  WaitForHandleConfig({
    table: waitForHandleTable,
    operations: waitForHandleOperations,
    cityList,
    remoteCarList,
  }),
)
onMounted(() => {
  // 处理url中参数，本次先增加车牌号和车辆id
  const { plateNo: carPlateNo = '', id = '' } = route.query
  if (carPlateNo) {
    remoteCarList(carPlateNo)
    waitForHandleConfig.value.formData.formProps.model = {
      plateNo: id ? Number(id) : '',
      id,
    }
  }
  getCoolingType()
  // 获取车辆标签
  getTenantCustomTagList({ type: 1 }).then((res) => {
    const { data = [] } = res || {}
    carTags.value = data
    setItemData('tagId', data)
  })
  // 获取车源方
  getCarProvider({ state: 1, serviceType: 0 }).then((res) => {
    const { code, data = {} } = res || {}
    if (code === 1) {
      providerList.value = data.items
      setItemData('providerId', data.items)
    }
  })
})
</script>
<style lang="scss" scoped>
::v-deep .wait-for-handle-card {
  background-color: #fff !important;
  padding: 0 !important;
  .cell {
    padding: 0 !important;
  }
}
#car-list ::v-deep .el-table__body .el-table__row td.wait-for-handle-card {
  border-bottom: none !important;
}
::v-deep .el-table__row:hover .wait-for-handle-card {
  background-color: #fff !important;
}
::v-deep .el-table__body-wrapper {
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
}
</style>
